import React, { useEffect } from 'react'
import { useTheme } from '@emotion/react'
import { useInstantSearch, useHierarchicalMenu } from 'react-instantsearch'
import { Link } from 'gatsby'

const containerStyle = {
	display: 'flex',
	overflow: 'auto',
	maxWidth: 'calc(100% + 16px)',
	gap: 8,
	paddingBottom: 8,
	marginRight: -16,
}

export default function Facets({ rootPath }) {
	const { setIndexUiState } = useInstantSearch()
	
	// https://www.algolia.com/doc/api-reference/widgets/hierarchical-menu/react/
	const { items } = useHierarchicalMenu({
		attributes: [
			'data.categories.lvl0',
			'data.categories.lvl1',
		],
		rootPath,
		sortBy: ['name:asc'],
	})
	
	// https://www.algolia.com/doc/api-reference/widgets/hierarchical-menu/react/#widget-param-rootpath
	useEffect(() => {
		setIndexUiState((prevIndexUiState) => ({
			...prevIndexUiState,
			hierarchicalMenu: {
				...prevIndexUiState.hierarchicalMenu,
				data: {
					categories: {
						lvl0: rootPath,
					}
				}
			}
		}))
	}, [])

	return (
		<div css={containerStyle}>
			{items.map(item => <Facet
				key={item.value} 
				item={item}
				rootPath={rootPath}
			/>)}
		</div>
	)
}

function Facet({ item, rootPath }) {
	const theme = useTheme()
	const path = rootPath.toLowerCase().replaceAll(' ', '-')
	return(
		<Link
			to={`/${path}?filter=${encodeURI(item.label)}`}
			css={{
				flexShrink: 0,
				margin: 0,
				padding: '10px 12px 8px 12px',
				background: 'transparent',
				border: `1px solid ${theme.colors.mutedLight}`,
				borderRadius: 24,
				color: 'white',
				transition: 'all .25s ease',
				'&:hover': {
					cursor: 'pointer',
					backgroundColor: theme.colors.mutedLight,
					color: 'black',
				}
			}}
		>
			{item.label}
		</Link>
	)
}